import { type Subscription } from '@air/api/types';
import { BYTES_GIGABYTE } from '@air/utilities';

import { shouldUseFixedPlanUsageLayout } from '~/utils/shouldUseFixedPlanUsageLayout';

/** Fixed plans without a hard storage cap (Business) still include an allowance to measure against. */
export const getFixedPlanIncludedStorageBytes = (
  subscription: Pick<Subscription, 'pricingModel' | 'includedGb'> | undefined,
): number | null =>
  shouldUseFixedPlanUsageLayout(subscription) && subscription?.includedGb
    ? subscription.includedGb * BYTES_GIGABYTE
    : null;
